<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EVziwu/tc-custom/9781497620308.jpg?1733032333371" alt="This image is the cover for the book Midsummer Moon, Regency Tales"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Midsummer Moon, Regency Tales
      </h1>
      <p class="bookDescription body article font2">
        <b>A duke’s well-ordered world is turned upside down when a female inventor sends his heart soaring in this Regency romance by a <i>New York Times</i>–bestselling author. </b><br/>  <br/> Merlin Lambourne has invented the “speaking box”—a sort of telephone—which is so valuable that Napoleon has killed for it. Sent by the crown to bring both inventor and invention to safety, Ransom Falconer, Duke of Damerell, is shocked to learn Mr. Lambourne is a Miss.<br/>  <br/> Perhaps more shocking, however, are his feelings for the eccentric genius. She is everything he doesn’t like: incapable of following orders, unaware of conventional etiquette, preoccupied, disorganized, and unkempt. Yet she beguiles him. One of the most ingenious inventors in England, she is also one of the country’s greatest hopes in the defense against the power mad Napoleon Bonaparte. Now, if he could just get her mind out of the clouds and convince her to marry him . . .<br/><br/> Merlin is not absentminded, it’s just that she only seems to be able to pay attention to one thing at a time. And maybe she does take everything people say literally, but people ought to say what they mean. Now this Ransom Falconer wants her to forget her current interest in flying machines and focus on the speaking box she’s lost interest in finishing. It’s quite disconcerting. In fact, everything about him is disconcerting; in her isolated life Merlin has never met anyone who affects her quite like Ransom does.<br/>  <br/> With her trademark blend of heartwarming characters and a hilarious conflict, <i>Midsummer Moon</i> is yet another winner from the author of <i>Flowers from the Storm</i>, praised by Lisa Kleypas as “the gold standard in historical romance.”<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laura Kinsale
      </h2>
      
      <p class="authorDescription body article">&amp;lt;p&amp;gt;Laura Kinsale is a winner and multiple nominee for the Best Book of the Year award given by the Romance Writers of America. She became a romance writer after six years as a geologist -- a career which consisted of getting out of bed in the middle of the night and driving hundreds of miles alone across west Texas to sit at drilling rigs, wear a hard hat, and attempt to boss around oil-covered males considerably larger than herself. This, she decided, was pushing her luck. So she gave all that up to sit in a chair and stare into space for long periods of time, attempting to figure out What-Happens-Next. She and her husband David currently divide their time between Santa Fe, New Mexico, and Texas.&amp;lt;/p&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?de478f94